import React from "react";

import { connect } from "react-redux";
import { Form } from "react-form";
import { Card } from "primereact/card";

import ClientTable from "../components/client/client-table";
import ClientDetails from "../components/client/client-details";

import * as annualReturnClientActionCreators from "../actionCreators/annualReturnClient";
import * as employeeActionCreators from "../actionCreators/employee";
import * as appActionCreators from "../actionCreators/app";
class AnnualReturnClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNew: false,
      isDisplayingDialog: false, // determines whether client details dialog is hidden or shown
      selectedClient: {}, // determines what client is selcted in the table. It will be highlighted
      employeeOptionsByLobbyist: [],
    };
  }

  // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = (annualReturnClient) => {
      annualReturnClient.AnnualReturnClientStartDate = annualReturnClient.AnnualReturnClientStartDate ? new Date(annualReturnClient.AnnualReturnClientStartDate) : null
      annualReturnClient.AnnualReturnClientEndDate = annualReturnClient.AnnualReturnClientEndDate ? new Date(annualReturnClient.AnnualReturnClientEndDate) : null
    // if id exists then we are updating otherwise we are adding
    // use actionCreators that have been injected in as props. This happens when the higher order component connect is used
    if (annualReturnClient.AnnualReturnClientId) {
      this.saveClient(annualReturnClient, this.props.updateAnnualReturnClient);
    } else {
      annualReturnClient.LobbyistId = this.props.lobbyistId;
      this.saveClient(annualReturnClient, this.props.addAnnualReturnClient);
    }
  };

  // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  saveClient = (annualReturnClient, save) => {
    if (this.state.addNew === true) annualReturnClient.addNew = true;
    else annualReturnClient.addNew = false;

    this.setState({ addNew: false });

    this.props
      .setLoading(true)
      .then(() => save(annualReturnClient))
      .then((response) => {
        // set response in store so global response component can handle response
        /*
            response json structure is:
            {
                "$id":"1",
                "SuccessOutput":null,
                "Success":false,
                "ErrorMessages":{
                    "$id":"2",
                    "$values":[
                        "Name is required"
                    ]
                },
                "WarningMessages":{
                    "$id":"3",
                    "$values":[

                    ]
                }
            }
        */
        this.props.setAjaxResponse(response);
        if (response.data.Success) {
          // close dialog by calling function that has been passed in by containing component
          // this is because the state that determines whether the dialog is showing is in the containing component
          this.closeClientDetails();
        }

        if (annualReturnClient.addNew === true) {
          window.setTimeout(() => {
            this.loadAndOpenClientDetails(response.data.SuccessOutput);
          }, 1000);
          this.props.getClientsForAnnualReturn(
            this.props.lobbyistId,
            this.props.currentAnnualReturn
          );
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) =>
        this.props.handleError(error).then(() => this.props.setLoading(false))
      );
  };

  deleteClient = (clientId) => {
    if (clientId) {
      this.props
        .setLoading(true)
        .then(() => this.props.deleteClient(clientId))
        .then((response) => {
          // set response in store so global response component can handle response
          this.props.setAjaxResponse(response);
          if (response.data.Success) {
            // close dialog by calling function that has been passed in by containing component
            // this is because the state that determines whether the dialog is showing is in the containing component
            this.closeClientDetails();
          }
        })
        .then(() => this.props.setLoading(false))
        .catch((error) =>
          this.props.handleError(error).then(() => this.props.setLoading(false))
        );
    }
  };

  justSaveClient = (submitForm) => {
    this.setState({ addNew: false });
    submitForm.call(this);
  };

  saveAndAddClient = (submitForm) => {
    this.setState({ addNew: true });
    submitForm.call(this);
  };

  addClient = () => this.loadAndOpenClientDetails(null);
  selectClient = (e) => {
    this.loadAndOpenClientDetails(e.data);
  };

  loadAndOpenClientDetails = (annualReturnClient) => {
    let annualReturnClientId = annualReturnClient
      ? annualReturnClient.AnnualReturnClientId
      : null;
    let clientId = annualReturnClient ? annualReturnClient.ClientId : null;
    let annualReturnId = this.props.annualReturnId;
    let lobbyistId = this.props.lobbyistId;
    
    this.props
      .setLoading(true)
      .then(() =>
        this.props.getEmployeesForLobbyistByDate(
          lobbyistId,
          this.props.currentAnnualReturn.StartDate,
          this.props.currentAnnualReturn.EndDate
        )
      )
      .then(() =>
        this.props.getAnnualReturnClient(
          clientId,
          annualReturnId,
          annualReturnClientId
        )
      )
      .then(() => {
        let currentAnnualReturnClient =
          this.props.annualReturnClient.currentAnnualReturnClient || {};
        if (currentAnnualReturnClient.PublicOfficialMet === " ")
          currentAnnualReturnClient.PublicOfficialMet = null;
        if (currentAnnualReturnClient.SubjectDiscussed === " ")
          currentAnnualReturnClient.SubjectDiscussed = null;

        this.setState({
          isDisplayingDialog: true,
          selectedClient: currentAnnualReturnClient || {},
        });

      })
      .then(() => this.props.setLoading(false))
      .catch((error) =>
        this.props.handleError(error).then(() => this.props.setLoading(false))
      );
  };

  closeClientDetails = (annualReturnClient, resetForm) => {
    if (resetForm) {
      resetForm(); // Reset validation and form state
    }

    if (typeof annualReturnClient !== "undefined") {
      if (
        annualReturnClient.AnnualReturnClientId != null &&
        annualReturnClient.PublicOfficialMet == null
      ) {
        this.props
          .removeAnnualReturnClient(annualReturnClient.AnnualReturnClientId)
          .then(() => {
            this.props.getClientsForAnnualReturn(
              this.props.lobbyistId,
              this.props.currentAnnualReturn
            );
          });
      }
    }
    this.setState({ isDisplayingDialog: false, selectedClient: {} });

    // clear loaded client in store otherwise there is an issue when opening a different lobbyist and the Calendar component where Uncaught TypeError: viewDate.getMonth is not a function
    this.props.clearAnnualReturnClient();
  };

  render() {
    // check if current client that is being looked at exists. If not create an empty object to deal with issues that could be caused by client being undefined
    // i.e. when binding to client.Entity.ClientName there could be issues when client is undefined since we are trying to access a property off of a propery
    let currentAnnualReturnClient = this.props.annualReturnClient
      .currentAnnualReturnClient
      ? this.props.annualReturnClient.currentAnnualReturnClient
      : {};
    let clients = this.props.annualReturnClient.annualReturnClients
      ? this.props.annualReturnClient.annualReturnClients
      : [];
    let isAdd = !currentAnnualReturnClient.ClientId;
    let isAuthenticated = this.props.auth.isAuthenticated;

    let subTitle = isAuthenticated
      ? "Complete each line of the table below with the name of official contacted and the topic discussed. Click on the row to add the information. If no communication took place insert ‘nil’."
      : "";

    let clientTableProps = {
      canSave: this.props.canSave,
      clients: clients,
      selectClient: this.selectClient,
      addClient: this.addClient,
      selectedClient: this.state.selectedClient,
      isAnnualReturn: true,
    };

    if (
      currentAnnualReturnClient["PublicOfficialMet"] !== undefined &&
      currentAnnualReturnClient["PublicOfficialMet"] === " "
    )
      currentAnnualReturnClient["PublicOfficialMet"] = null;

    if (
      currentAnnualReturnClient["SubjectDiscussed"] !== undefined &&
      currentAnnualReturnClient["SubjectDiscussed"] === " "
    )
      currentAnnualReturnClient["SubjectDiscussed"] = null;
    return (
      <Card title="Clients" subTitle={subTitle}>
        <ClientTable {...clientTableProps} />
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
        this is useful when needed to clear the form or populating the form from another component
        onSubmit is called when the form has been submitted and has passed validation
        formApi properties can be found at https://react-form.js.org/#/*/}
        <Form
          values={currentAnnualReturnClient}
          onSubmit={this.formSubmittedSuccessfully}
        >
          {(formApi) => {
            let clientDetailsProps = {
              currentClient: currentAnnualReturnClient,
              canSave: this.props.canSave,
              submitForm: formApi.submitForm,
              resetForm: formApi.resetAll,
              isAdd: isAdd,
              deleteClient: this.deleteClient,
              isDisplayingDialog: this.state.isDisplayingDialog,
              closeClientDetails: this.closeClientDetails,
              isAnnualReturn: true,
              saveAndAddClient: this.saveAndAddClient,
              saveClient: this.justSaveClient,
              employeeOptions: this.props.employeeOptions
            };
            return <ClientDetails {...clientDetailsProps} />;
          }}
        </Form>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  let { annualReturnClient, auth, annualReturnEmployee, employee } = state;
  return { annualReturnClient, auth, annualReturnEmployee, employee, employeeOptions: employee.employeesForLobbyistByDate || [] };
};

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...annualReturnClientActionCreators,
  ...employeeActionCreators,
};

export default connect(mapStateToProps, actionCreators)(AnnualReturnClient);



// WEBPACK FOOTER //
// ./src/container/AnnualReturnClient.js